const translations = {
  // Navbar
  'nav.solutions': 'Solutions',
  'nav.process': 'Process',
  'nav.pricing': 'Pricing',
  'nav.contact': 'Contact',
  'nav.blog': 'Blog',
  'nav.challenges': 'Challenges',
  'nav.cta': 'Get Started',

  // Hero section
  'hero.badge': 'Websites and systems at a fixed price',
  'hero.titleLine1': 'Your website in 48 hours.',
  'hero.titleLine2': 'One fixed price.',
  'hero.title': 'Synapsis Team',
  'hero.subtitle': 'Landing page, portfolio, company site or catalog — they all cost the same. And you do not pay until you see it finished and working.',
  'hero.button.start': 'Get my website',
  'hero.button.solutions': 'See pricing',
  'hero.stat.number1': 'Enterprise AI',
  'hero.stat.number2': 'Automation',
  'hero.stat.number3': 'Cloud & DevOps',
  'hero.stat.number4': 'Security',
  'hero.stat.website': 'Talk about Enterprise AI',
  'hero.stat.companySystem': 'Talk about Automation',
  'hero.stat.automatization': 'Talk about Cloud & DevOps',
  'hero.stat.digitalTransformation': 'Talk about Security',
  'hero.stat.consulting': 'Hi! I would like to talk about',
  'hero.stat.consultingSecondPart': 'Can we set up a call?',

  // Solutions (now includes what used to be a separate "Features" section)
  'solutions.label': 'Solutions',
  'solutions.title': 'Solutions',
  'solutions.titleHighlight': 'built to fit',
  'solutions.subtitle': 'Six areas of work, one goal: making your business run faster with less friction.',
  'solutions.ai.title': 'Enterprise AI',
  'solutions.ai.description': 'AI models applied to real problems: demand forecasting, data analysis, and automated decision-making.',
  'solutions.ai.features': 'Predictive Analytics,NLP,Computer Vision,Deep Learning',
  'solutions.automation.title': 'Process Automation',
  'solutions.automation.description': 'We remove repetitive tasks and connect your tools so work flows on its own.',
  'solutions.automation.features': 'RPA,API Integration,Workflow Automation,Scheduled Tasks',
  'solutions.systems.title': 'Custom Systems',
  'solutions.systems.description': 'ERP, CRM, and internal software designed around how your team actually works.',
  'solutions.systems.features': 'ERP,CRM,BPM,Custom Software',
  'solutions.cloud.title': 'Cloud & DevOps',
  'solutions.cloud.description': 'Scalable infrastructure and automated deployments, with no surprises or downtime.',
  'solutions.cloud.features': 'AWS,Azure,GCP,CI/CD',
  'solutions.bi.title': 'Analytics & BI',
  'solutions.bi.description': 'Dashboards and reports that turn scattered data into clear decisions.',
  'solutions.bi.features': 'Dashboards,KPIs,Automated Reports,Data Analytics',
  'solutions.security.title': 'Security & Compliance',
  'solutions.security.description': 'Encryption, continuous monitoring, and best practices from day one of development.',
  'solutions.security.features': 'Encryption,Continuous Monitoring,Access Control,Backups',
  'solutions.contactUs': "Let's talk about your project",

  // Work Process
  'process.label': 'How we work',
  'process.title': 'From idea to',
  'process.titleHighlight': 'launch',
  'process.subtitle': 'Four steps. No discovery meetings, no quotes going back and forth.',
  'process.step1.title': 'You email us',
  'process.step1.description': 'Tell us what you need and send your logo, your copy if you have it, and examples you like.',
  'process.step2.title': 'We start the same day',
  'process.step2.description': 'You already know the price and the date, so there is nothing to quote. We just start.',
  'process.step3.title': 'We show it to you running',
  'process.step3.description': 'You see it actually working, not a mockup. If something needs adjusting, we adjust it.',
  'process.step4.title': 'It goes live',
  'process.step4.description': 'We hand over the domain and hosting configured, and walk you through running it.',

  // Tech
  'tech.label': 'Tech stack',
  'tech.title': 'What we build with',

  // Pricing
  'pricing.title': 'One price.',
  'pricing.titleHighlight': 'One date.',
  'pricing.subtitle': 'What you see is what you pay. No basic, pro and enterprise tiers. No fees that show up later.',
  'pricing.currency': '$',
  'pricing.currencyCode': 'USD',
  'pricing.period': '',

  'pricing.web.name': 'Website',
  'pricing.web.price': '499',
  'pricing.web.delivery': 'Live in 48 hours',
  'pricing.web.description': 'Landing page, portfolio, company site or catalog. Same price for all of them.',
  'pricing.web.feature1': 'Custom design, built for your brand',
  'pricing.web.feature2': 'Copy written and included',
  'pricing.web.feature3': 'Looks right on phone and desktop',
  'pricing.web.feature4': 'Contact form that emails you',
  'pricing.web.feature5': 'Ready for Google from day one',
  'pricing.web.feature6': 'WhatsApp and social links connected',
  'pricing.web.feature7': 'Domain, hosting and code all stay in your name',
  'pricing.web.cta': 'Get my website',

  'pricing.system.name': 'Web system',
  'pricing.system.price': '2,499',
  'pricing.system.delivery': 'Live in 7 days',
  'pricing.system.description': 'To run your business. You open it in the browser, nothing to install.',
  'pricing.system.feature1': 'You pick what it does: bookings, orders, inventory, clients, invoicing or internal management',
  'pricing.system.feature2': 'Users with permissions: everyone sees only their part',
  'pricing.system.feature3': 'Admin panel so you can run it yourself',
  'pricing.system.feature4': 'A database with your information, always yours',
  'pricing.system.feature5': 'Works from any computer or phone',
  'pricing.system.feature6': 'Automatic backups',
  'pricing.system.feature7': 'We walk you through it on a call',
  'pricing.system.cta': 'Get my system',

  'pricing.guarantee': 'You do not pay until you see it finished and working.',
  'pricing.guaranteeSub': 'We build it, we show it to you running, and only then do we talk about money.',
  'pricing.customSolution': 'Need something bigger?',
  'pricing.contactUs': 'Tell us what you have in mind',

  // FAQ
  'faq.label': 'Frequently asked questions',
  'faq.title': 'Before we',
  'faq.titleHighlight': 'start',
  'faq.q1': '48 hours, really?',
  'faq.a1': 'Yes. Send us your information on a Monday and your site is live on Wednesday. We can do it because we do not reinvent the technical side on every project — that part is already solved, so we spend the time on yours.',
  'faq.q2': 'Is that the real price, or do extras show up later?',
  'faq.a2': 'That is the price. It covers design, copy, the site working, and your domain and hosting set up. There is no mandatory maintenance fee and no surprise in month two.',
  'faq.q3': 'What if I do not like it?',
  'faq.a3': 'We adjust it. You do not pay until you see it finished and you are happy with it, so the risk is ours, not yours.',
  'faq.q4': 'Can I change things myself afterwards?',
  'faq.a4': 'Text and images, yes — we hand it over so you can edit them without writing code. And if you want us to make a change, you email us and we do it.',
  'faq.q5': 'What is the difference between the website and the system?',
  'faq.a5': 'The website is how people find you, see what you do and get in touch. The system is the tool you work with: bookings, orders, inventory or clients, managed from the inside. Plenty of clients start with the website and add the system as they grow.',
  'faq.q6': 'Do you work with clients abroad?',
  'faq.a6': 'Yes. We work with clients in Argentina and the United States, all remote. Time zones have never been a problem.',

  // CTA / Contact
  'cta.title': "Let's talk about your",
  'cta.titleHighlight': 'project',
  'cta.subtitle': "Got a technical problem or an idea in mind? Tell us what you need.",
  'cta.feature1.title': 'Fast response',
  'cta.feature1.subtitle': 'We get back to you without layers of account management in between.',
  'cta.feature2.title': 'Direct communication',
  'cta.feature2.subtitle': "You talk to the people building your project, not a salesperson.",
  'cta.feature3.title': 'A date we hit',
  'cta.feature3.subtitle': 'We give you a specific day and it is ready that day. No excuses.',
  'cta.form.name': 'Name',
  'cta.form.namePlaceholder': 'Your name',
  'cta.form.email': 'Email',
  'cta.form.emailPlaceholder': 'Your email',
  'cta.form.company': 'Company',
  'cta.form.companyPlaceholder': 'Your company',
  'cta.form.message': 'Message',
  'cta.form.messagePlaceholder': 'Tell us about your project',
  'cta.form.successTitle': 'Message sent!',
  'cta.form.successMessage': 'Your message has been sent successfully. We will contact you soon.',
  'cta.form.errorTitle': 'Error',
  'cta.form.errorMessage': 'An error occurred while sending the message. Please try again.',
  'cta.form.sending': 'Sending...',
  'cta.form.sendAnother': 'Send another message',
  'cta.form.tryAgain': 'Try again',
  'cta.button': 'Send message',

  // Footer
  'footer.companyDescription': 'Synapsis Team designs, builds, and maintains software, AI, and automation for companies that want to move faster.',
  'footer.quickLinks': 'Quick Links',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms and Conditions',
  'footer.cookies': 'Cookie Policy',
  'footer.rights': `© ${new Date().getFullYear()} Synapsis Team. All rights reserved.`,

  // Cookie consent
  'cookie.message': 'We use cookies to understand how the site is used and improve it. You can decline and the site works exactly the same. More detail in our',
  'cookie.manage': 'Manage cookies',
  'cookie.link': 'cookie policy',
  'cookie.accept': 'Accept',
  'cookie.reject': 'Decline',
};

export default translations;
